import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { INavigateCollectionTriageClipRequest } from './navigate-collection-triage-clip-request';
import type { INavigateCollectionTriageClipResponse } from './navigate-collection-triage-clip-response';
import { navigateCollectionTriageClipResponseSchema } from './navigate-collection-triage-clip-response';

/**
 * @deprecated Superseded by `navigateCollectionTriageClipV3Api`. Frozen, not
 * deleted - an old app binary may still call it. See "Web-only / orphan versions
 * pending deletion" in apps/api/CLAUDE.md.
 */
export async function navigateCollectionTriageClipApi({
  collectionId,
  clipId,
  direction,
}: INavigateCollectionTriageClipRequest): Promise<
  IValidatedResponse<INavigateCollectionTriageClipResponse>
> {
  return getRequest<INavigateCollectionTriageClipResponse>({
    path: `/sys/collections/${collectionId}/triage/navigate?clipId=${clipId}&direction=${direction}`,
    schema: navigateCollectionTriageClipResponseSchema,
  });
}
